module.exports = __webpack_public_path__ + "img/SCB0216.9a031b07.png";